import { gql } from '@apollo/client'

export const REDO_SCORM = gql`
  mutation RedoScorm($userId: Int!, $scormId: Int!) {
    redoScorm(userId: $userId, scormId: $scormId)
  }
`
